import "./Error404.css"


function Error404() {
    return <header className="img">
        <img src={require("../../assets/Images/Error404.png")} alt='Org' />
    </header>
}

export default Error404